import { useState, useEffect } from 'react';
import { auth, functions } from '../firebase/firebase';
import { httpsCallable } from 'firebase/functions';
import { createPerformanceLogger, logFunctionCall } from '../utils/performanceLogging';

const logger = createPerformanceLogger('auth');

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      const end = logger.start('auth_state_changed');
      if (user) {
        setUser(user);
        try {
          const checkAdminEnd = logger.start('check_admin');
          const checkIfAdmin = httpsCallable(functions, 'checkIfAdmin');
          const result = await logFunctionCall('checkIfAdmin', () => checkIfAdmin({ email: user.email }));
          setIsAdmin(result.data.isAdmin);
          setUserName(result.data.userName);
          checkAdminEnd();
        } catch (error) {
          console.error('Error checking admin status:', error);
        }
      } else {
        setUser(null);
        setIsAdmin(false);
        setUserName('');
      }
      setLoading(false);
      setAuthChecked(true);
      end();
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    const end = logger.start('logout');
    await auth.signOut();
    end();
  };

  return { user, isAdmin, userName, loading, authChecked, handleLogout };
};